import { render } from "./InfoCard.vue?vue&type=template&id=6a7d726b&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"

import "./InfoCard.vue?vue&type=style&index=0&id=6a7d726b&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7d726b"]])

export default __exports__